import { handleActions } from "redux-actions";

import {
    LEGACY_REQUEST_ACCESS_REQUEST,
    LEGACY_REQUEST_ACCESS_COMPLETED,
    CONNECTION_REQUESTS_FOR_BUYER,
} from "constants/action-types";

const initialState = {
    isFetching: false,
    error: undefined,
    requestedConnections: [],
};

const legacyRetailersReducer = handleActions(
    {
        [LEGACY_REQUEST_ACCESS_REQUEST]: (state) => {
            return Object.assign({}, state, {
                isFetching: true,
            });
        },
        [LEGACY_REQUEST_ACCESS_COMPLETED]: (state, { error, payload }) => {
            return Object.assign({}, state, {
                isFetching: false,
                error: error ? payload : undefined,
                requestedConnections: error
                    ? state.requestedConnections
                    : [...state.requestedConnections, payload.requestedConnection],
            });
        },
        [CONNECTION_REQUESTS_FOR_BUYER]: (state, { error, payload }) => ({
            ...state,
            isFetching: false,
            error,
            requestedConnections: error ? state.requestedConnections : [...payload],
        }),
    },
    initialState,
);

export default legacyRetailersReducer;
